import withIcon from './NewIcon';
// @ts-ignore
import IconArrowRightM from './icon/m/arrow-right.s.svg';

export default withIcon(IconArrowRightM);
